<template>
  <div class="pa-3 grey lighten-4">
    <v-card flat class="card--flex-toolbar transparent">
      <v-card-text class="pa-0">
        <v-form ref="form">
          <v-card>
            <v-card-title class="grey lighten-4 pa-2">
              <h3 class="secondary--text">
                {{ $t("screener.admin.company.audience_registration") }}
              </h3>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="onSave()" small>Save</v-btn>
            </v-card-title>
            <v-card-text>
              <!-- Registration configuration -->
              <v-flex xs12 class="px-3 pt-3">
                <!-- Reminder Time -->
                <v-text-field
                  v-model="company.reg_configuration.reminder_time"
                  color="primary"
                  :label="
                    $t('screener.admin.company.registration.reminder_time')
                  "
                  :rules="[
                    rules.required,
                    rules.numeric,
                    rules.inBetween(
                      60,
                      180,
                      company.reg_configuration.reminder_time
                    ),
                  ]"
                ></v-text-field>
                <!-- Send Reminder -->
                <v-checkbox
                  v-model="company.reg_configuration.send_reminder"
                  color="primary"
                  :label="
                    $t('screener.admin.company.registration.send_reminder')
                  "
                >
                  <template v-slot:append>
                    <v-tooltip top color="white">
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-information-outline</v-icon>
                      </template>
                      <span
                        class="greyDarken3--text body-1"
                        v-html="
                          $t(
                            'screener.admin.company.registration.send_reminder.tooltip'
                          )
                        "
                      ></span>
                    </v-tooltip>
                  </template>
                </v-checkbox>
                <!-- Verification Required -->
                <v-checkbox
                  v-model="company.reg_configuration.verification_required"
                  color="primary"
                  :label="
                    $t(
                      'screener.admin.company.registration.verification_required'
                    )
                  "
                >
                  <template v-slot:append>
                    <v-tooltip top color="white">
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-information-outline</v-icon>
                      </template>
                      <span class="greyDarken3--text body-1">
                        {{
                          $t(
                            "screener.admin.company.registration.verification_required.tooltip"
                          )
                        }}
                      </span>
                    </v-tooltip>
                  </template>
                </v-checkbox>
                <!-- Show Mobile Input -->
                <v-checkbox
                  v-model="company.reg_configuration.is_mobile_visible"
                  color="primary"
                  :label="
                    $t('screener.admin.company.registration.is_mobile_visible')
                  "
                >
                  <template v-slot:append>
                    <v-tooltip top color="white">
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-information-outline</v-icon>
                      </template>
                      <span
                        class="greyDarken3--text body-1"
                        v-html="
                          $t(
                            'screener.admin.company.registration.is_mobile_visible.tooltip'
                          )
                        "
                      ></span>
                    </v-tooltip>
                  </template>
                </v-checkbox>
                <!-- Mobile Required -->
                <v-checkbox
                  v-model="company.reg_configuration.mobile_required"
                  color="primary"
                  :label="
                    $t('screener.admin.company.registration.mobile_required')
                  "
                >
                  <template v-slot:append>
                    <v-tooltip top color="white">
                      <template v-slot:activator="{ on }">
                        <v-icon v-on="on">mdi-information-outline</v-icon>
                      </template>
                      <span
                        class="greyDarken3--text body-1"
                        v-html="
                          $t(
                            'screener.admin.company.registration.mobile_required.tooltip'
                          )
                        "
                      ></span>
                    </v-tooltip>
                  </template>
                </v-checkbox>
              </v-flex>
            </v-card-text>
          </v-card>
          <v-card class="mt-3">
            <v-card-title class="grey lighten-4 pa-2">
             <h3 class="secondary--text">
                      {{ $t("screener.admin.company.monetization") }}
                      <v-tooltip top color="white">
                        <template v-slot:activator="{ on }">
                          <v-icon size="19" v-on="on"
                            >mdi-information-outline</v-icon
                          >
                        </template>
                        <span
                          class="greyDarken3--text body-1"
                          v-html="
                            $t('screener.admin.company.monetization.tooltip')
                          "
                        ></span>
                      </v-tooltip>
                    </h3>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="onSave()" small>Save</v-btn>
            </v-card-title>
            <v-card-text>
                <v-flex xs12 class="px-3">
                    <v-text-field
                      v-model="company.currency"
                      :prefix="getCurrencySymbol()"
                      readonly
                      color="primary"
                      :label="$t('company.save.currency.title')"
                    >
                      <template v-slot:append>
                        <v-tooltip top color="white">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">mdi-information-outline</v-icon>
                          </template>
                          <span
                            class="greyDarken3--text body-1"
                            v-html="
                              $t('company.save.currency.tooltip') +
                              $t(
                                'screener.admin.company.monetization.currency.tooltip'
                              )
                            "
                          ></span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                    <!-- Revenue calculation time in hours -->
                    <v-text-field
                      v-model="company.custom_properties.revenue_calculation_time"
                      color="primary"
                      :label="
                        $t(
                          'screener.admin.company.registration.revenue_calculation_time'
                        )
                      "
                      :rules="[
                        rules.required,
                        rules.numeric,
                        rules.inBetween(
                          48,
                          72,
                          company.custom_properties.revenue_calculation_time
                        ),
                      ]"
                    >
                      <template v-slot:append>
                        <v-tooltip top color="white">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">mdi-information-outline</v-icon>
                          </template>
                          <span
                            class="greyDarken3--text body-1"
                            v-html="
                              $t(
                                'screener.admin.company.registration.revenue_calculation_time.tooltip'
                              )
                            "
                          ></span>
                        </v-tooltip>
                      </template>
                    </v-text-field>

                    <v-text-field
                      v-model="company.custom_properties.booking_revenue_calculation_time"
                      color="primary"
                      :label="
                        $t(
                          'screener.admin.company.registration.booking_revenue_calculation_time'
                        )
                      "
                      :rules="[
                        rules.required,
                        rules.numeric,
                        rules.inBetween(
                          48,
                          72,
                          company.custom_properties.booking_revenue_calculation_time
                        ),
                      ]"
                    >
                      <template v-slot:append>
                        <v-tooltip top color="white">
                          <template v-slot:activator="{ on }">
                            <v-icon v-on="on">mdi-information-outline</v-icon>
                          </template>
                          <span
                            class="greyDarken3--text body-1"
                            v-html="
                              $t(
                                'screener.admin.company.registration.booking_revenue_calculation_time.tooltip'
                              )
                            "
                          ></span>
                        </v-tooltip>
                      </template>
                    </v-text-field>

<!-- <v-tooltip color="black" bottom >
        <template v-slot:activator="{ on, attrs }">
          <div
            v-bind="attrs"
              v-on="on"
             style="width:min-content;"
          > -->
          <!-- </div>
        </template>
        <div>
          Tooltip
        </div>
</v-tooltip> -->

                    <div class="mb-3 subheading">
                      <span class="greyDarken2--text"
                        >System Commission Percentage</span
                      ><span class="px-1">:</span
                      ><span
                        ><b>{{ company.commission_percentage }}&nbsp;%</b></span
                      >
                      <div class="greyDarken3--text">
                        <small
                          >There will be
                          <b>{{ company.commission_percentage }}&nbsp;%</b>
                          system share on the ticket's total price if you
                          monetise any event.</small
                        >
                      </div>
                    </div>
                  </v-flex>
            </v-card-text>
          </v-card>
          <!-- OAuth Settings -->
          <OAuthSettings v-if="company" :company.sync="company" @onGenerateNewOAuthSecret="$emit('onGenerateNewOAuthSecret')" @onSave="onSave()"></OAuthSettings>
          <!-- Gateway settings -->
          <v-card class="mt-3">
            <v-card-title class="grey lighten-4 pa-2">
              <h3 class="secondary--text">{{$t('screener.payment_setting.title')}}</h3>
              <v-spacer></v-spacer>
              <v-btn color="success" @click.stop="onSave()" small>{{$t('rms.button.save')}}</v-btn>
            </v-card-title>
            <v-card-text>
              <PaymentGatewaySetting ref="gatewaySettingForm" :company="company"></PaymentGatewaySetting>
            </v-card-text>
          </v-card>
          <v-card class="mt-3">
            <v-card-title class="grey lighten-4 pa-2">
              <h3 class="secondary--text">
                {{ $t("company.page.setting.section.language_and_timezone") }}
              </h3>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="onSave()" small>Save</v-btn>
            </v-card-title>
            <v-card-text>
              <!-- Registration configuration -->
              <v-flex xs12 class="px-3 pt-3">
                 <v-select
                    :items="DEFINES.LOCALES"
                    v-model="company.custom_properties.language"
                    :label="$t('screener.save.form.theme.language')"
                ></v-select>
                <v-autocomplete
                      v-model="company.custom_properties.timezone"
                      :items="DEFINES.SUPPORTED_TIMEZONES"
                      color="primary"
                      :label="$t('screener.admin.company.select_timezone')"
                    >
                      <template v-slot:selection="data">
                        {{ data.item }}
                        {{ momentTz.tz(data.item).format("Z z") }}
                      </template>
                      <template v-slot:item="data">
                        <template
                          v-if="
                            typeof data.item !== 'object' &&
                            !DEFINES.IGNORED_TIMEZONES.includes(data.item)
                          "
                        >
                          {{ data.item }}
                          {{ momentTz.tz(data.item).format("Z z") }}
                        </template>
                      </template>
                    </v-autocomplete>
              </v-flex>
            </v-card-text>
          </v-card>
          <v-card class="mt-3">
            <v-card-title class="grey lighten-4 pa-2">
              <h3 class="secondary--text">
                {{ $t("screener.admin.company.facebook_pixel") }}
              </h3>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="onSave()" small>Save</v-btn>
            </v-card-title>
            <v-card-text>
                <!-- Facebook Pixel -->
                  <v-flex xs12 class="px-3">
                    <v-text-field
                      v-model="company.custom_properties.fbpixelId"
                      color="primary"
                      :label="$t('rms.field.fbpixelId.label')"
                      placeholder="Facebook Pixel Id"
                    ></v-text-field>
                  </v-flex>
            </v-card-text>
          </v-card>
          <v-card class="mt-3">
            <v-card-title class="grey lighten-4 pa-2">
              <h3 class="secondary--text">
                {{ $t("screener.admin.company.support") }}
              </h3>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="onSave()" small>Save</v-btn>
            </v-card-title>
            <v-card-text>
                <!-- Facebook Pixel -->
                  <v-flex xs12 class="px-3">
                    <v-text-field
                      v-model="company.custom_properties.support.email"
                      color="primary"
                      :rules="[rules.email]"
                      :label="$t('rms.field.email.label')"
                      placeholder="Email"
                    ></v-text-field>
                    <v-text-field
                      v-model="company.custom_properties.support.phone"
                      color="primary"
                      type="number"
                      :label="$t('rms.table.header.phone')"
                      placeholder="+911234567890"
                      :hint="$t('screener.admin.company.support.phone.hint')"
                    ></v-text-field>
                  </v-flex>
            </v-card-text>
          </v-card>
          <v-card class="mt-3">
            <v-card-title class="grey lighten-4 pa-2">
              <h3 class="secondary--text">
                {{ $t("screener.admin.company.newsletter_mc") }}
              </h3>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="onSave()" small>Save</v-btn>
            </v-card-title>
            <v-card-text>
                <!-- MailChimp newsletter -->
                  <v-flex xs12 class="px-3">
                    <v-text-field
                      v-model="company.custom_properties.mcApiKey"
                      color="primary"
                      :label="$t('rms.field.mcApiKey.label')"
                      placeholder="MailChimp API key"
                      @input="$emit('getMailchimpLists',company)"
                      :hint="$t('screener.admin.company.newsletter_mc.hint')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="px-3">
                    <v-select
                      v-model="company.custom_properties.mcListId"
                      :items="mailchimpLists"
                      item-text="name"
                      item-value="id"
                      color="primary"
                      :label="$t('rms.field.mcListId.label')"
                      placeholder="MailChimp List"
                      :rules="
                        company.custom_properties.mcApiKey ? [rules.required] : []
                      "
                    ></v-select>
                  </v-flex>
            </v-card-text>
          </v-card>
          <!-- Company Message -->
          <v-card class="mt-3">
            <v-card-title class="grey lighten-4 pa-2">
              <h3 class="secondary--text">
                 {{$t('screener.admin.company.message')}}
                 <v-tooltip top color="white">
                    <template v-slot:activator="{ on }">
                      <v-icon size="19" v-on="on"
                        >mdi-information-outline</v-icon
                      >
                    </template>
                    <span class="greyDarken3--text body-1">
                      {{$t('screener.admin.company.message.tooltip')}}
                    </span>
                  </v-tooltip>
              </h3>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="onSave()" small>Save</v-btn>
            </v-card-title>
            <v-card-text>
              <v-flex xs12 class="px-3">
                <vue-editor
                  name="Message"
                  class="mt-2"
                  :value="company.custom_properties.message"
                  v-model="company.custom_properties.message"
                  :editor-toolbar="editorToolbar"
                  ref="vueeditor"
                ></vue-editor>
              </v-flex>
            </v-card-text>
          </v-card>
          <!-- Custom Emails settings -->
          <v-card class="mt-3">
            <v-card-title class="grey lighten-4 pa-2">
              <h3 class="secondary--text">{{ $t('company.customize_emails.title') }}</h3>
              <v-spacer></v-spacer>
              <!-- <v-btn color="success" @click.stop="onSave()" small>{{$t('rms.button.save')}}</v-btn> -->
            </v-card-title>
            <v-card-text class="pa-0">
              <CustomEmailsSetting :company="company"></CustomEmailsSetting>
            </v-card-text>
          </v-card>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { getCurrencySymbol, timezonesByCountry } from "@/helper";
import rules from "@/validation";
import { VueEditor} from "vue2-editor";
import DEFINES from "@/defines";
import PaymentGatewaySetting from "@/components/company/PaymentGatewaySetting";
import OAuthSettings from "@/components/company/OAuthSettings";
import CustomEmailsSetting from "@/components/company/CustomEmails";

export default {
  name: "CompanySetting",
  props: {
    company: {
      type: Object,
      default: null,
    },
    mailchimpLists: {
        type: Array,
        default: []
    }
  },
  components:{
    VueEditor,
    PaymentGatewaySetting,
    OAuthSettings,
    CustomEmailsSetting
  },
  data() {
    return {
      rules,
      is_editing: false,
      editorToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        ["link"],
        ["clean"],
        [{ 'direction': 'rtl' }],
      ],

    };
  },
  methods: {
    getCurrencySymbol() {
      return getCurrencySymbol(this.company.currency);
    },

    onSave() {
      // this.company.reg_configuration = this.local_reg_configuration;
      // if (!this.company.reg_configuration.hasOwnProperty("send_reminder")) {
      //   this.local_reg_configuration.send_reminder = true;
      // }
      // if (!this.company.reg_configuration.hasOwnProperty("is_mobile_visible")) {
      //   this.local_reg_configuration.is_mobile_visible = true;
      // }
      if (!this.$refs.form.validate()) {
        return false;
      }
      if(!this.$refs.gatewaySettingForm.validate()){
        return false;
      }
      this.$emit("onSave", this.company);
    },
  },
};
</script>
